import React, { useEffect, useState } from 'react';
import { useMobile } from 'frontend/src/hooks/useMobile';
import { useOnboardingContext } from '../../../contexts/Onboarding';
import { useSnackbarContext } from '../../../contexts/Snackbar';
import { useLinesContext } from '../../../contexts/Lines';
import { useEventTrackerContext } from '../../../contexts/EventTracker';
import { IProduct } from '../../../Types/product';
import { updateProduct } from '../../API';
import messages from '../../../messages';
import Step from '../BuildingBlocks/Stepper/Step';
import cloneDeep from 'lodash.clonedeep';
import ProductPicker from './ProductPicker';
import ProductList from './ProductList';

export default function SelectProduct({
  allSellerProducts,
}: {
  allSellerProducts: Array<IProduct>;
}) {
  const snackbar = useSnackbarContext();
  const mobile = useMobile();
  const { setLoading, goForward } = useOnboardingContext();
  const { products, setProducts } = useLinesContext();
  const { trackEvent } = useEventTrackerContext();
  const [options, setOptions] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [error, setError] = useState(null);

  async function handleSubmit() {
    if (!options) return;
    if (!selectedOption) {
      setError('Please select an option.');
      return;
    }
    setLoading(true);
    try {
      // NEED TO SET EVEN IF PRODUCT EXISTS TO CHANGE UPDATE TIME
      await updateProduct(selectedOption?.id, { confirmed: true });
      const productExists = products.find(
        (product) => product.id === selectedOption,
      );
      if (productExists) {
        const removeProduct = cloneDeep(products).filter(
          (product) => product.id === productExists.id,
        );
        const selectedProductOnEnd = removeProduct.concat(selectedOption);
        setProducts(selectedProductOnEnd);
      } else {
        const updatedProducts = cloneDeep(products);
        updatedProducts.push(selectedOption);
        setProducts(updatedProducts);
      }
      trackEvent({ event: 'selected_product', product: selectedOption });
      goForward();
    } catch (error) {
      snackbar.show(messages.general.saveError, 'error');
    }
    setLoading(false);
  }

  useEffect(() => {
    const allProductsCopy = cloneDeep(allSellerProducts);
    setOptions(allProductsCopy);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onSelect(id: string) {
    setError(null);
    setSelectedOption(options.find((product) => product.id === id));
  }

  return (
    <Step
      initialValues={{}}
      onSubmit={handleSubmit}
      error={error}
      setError={setError}
      component={() => {
        return (
          <>
            {mobile && options && (
              <>
                <ProductList
                  options={options}
                  selectedOption={selectedOption}
                  onSelect={onSelect}
                />
              </>
            )}
            {!mobile && options && (
              <ProductPicker
                options={options}
                selectedOption={selectedOption}
                onSelect={onSelect}
              />
            )}
          </>
        );
      }}
    />
  );
}
